import { format } from "date-fns";

export function formatToLocaleCurrency(currency) {
  const monetary = currency / 100;
  const options = { style: "currency", currency: "BRL" }
  return new Intl.NumberFormat("pt-BR", options).format(monetary);
};

export function formatToFormCurrency(currency) {
  const monetary = Math.round(currency * 100);
  return monetary;
};

export function formatToLocaleDate(date) {
  const newDate = new Date(date);
  const dateFormatted = format(newDate, "dd/MM/yyyy");
  return dateFormatted;
};

export function formatFormDate(date) {
  const newDate = new Date(date);
  const dateFormatted = format(newDate, "yyyy-MM-dd");
  return dateFormatted;
};
